import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function PartnersPage() {
  const { t } = useTranslation();

  useEffect(() => {
    document.title = "Partners & Collaboration | L+TV TÉLÉVISION";
  }, []);

  return (
    <div className="pt-20">
      <div className="bg-primary-900 py-8">
        <div className="ltv-container">
          <h1 className="text-2xl md:text-3xl font-bold text-white">{t("partners.title")}</h1>
          <p className="text-white/60 text-sm mt-1">{t("partners.subtitle")}</p>
        </div>
      </div>

      <div className="ltv-container py-8 md:py-12">
        <div className="max-w-3xl mx-auto text-center mb-12">
          <p className="text-foreground-700 leading-relaxed text-lg">
            {t("partners.intro")}
          </p>
        </div>

        <div className="bg-white rounded-lg border border-background-200 p-8 md:p-12 text-center mb-8">
          <div className="w-16 h-16 bg-primary-50 rounded-lg flex items-center justify-center text-primary-600 mx-auto mb-4">
            <i className="ri-hand-heart-line text-2xl"></i>
          </div>
          <h2 className="text-xl font-bold text-foreground-900 mb-3">{t("partners.ctaTitle")}</h2>
          <p className="text-foreground-600 mb-6 max-w-lg mx-auto">
            {t("partners.ctaDesc")}
          </p>
          <Link to="/contact" className="ltv-btn-accent text-sm inline-flex items-center gap-2">
            {t("partners.getInTouch")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </div>
  );
}